:host {
  display: block;
}

.JumpPaginationTable {
  --jump-pagination-table-label: var(--neutral-grey-secondary);
  --jump-pagination-table-arrows: var(--neutral-grey-secondary);
  --jump-pagination-table-arrows-disabled: var(--neutral-grey-disabled); //mappare una variabile del design system

  font-family: var(--ff-primary);

  &__Wrapper {
      display: flex;
      justify-content: space-between;
  
      .elementsPerPage {
        display: flex;
        gap: 1rem;
        align-items: center;
  
        label {
          color: var(--jump-pagination-table-label);
          font-size: var(--fs-300);
          font-weight: normal;
        }
      }
  
      .indicators {
        font-size: var(--fs-400);
        font-weight: normal;
        display: flex;
        justify-content: space-between;
        gap: 20px;
  
        color: var(--jump-pagination-table-label);
  
        .arrow {
          color: var(--jump-pagination-table-arrows);
          display: flex;
          align-items: center;
          gap: 10px;
  
          button {
            background-color: transparent;
            border: none;
            cursor: pointer;
            padding: 0px;
            display: flex;
            align-items: center;
          }
  
          button:disabled {
            cursor: not-allowed;
            color: var(--jump-pagination-table-arrows-disabled);
  
          }
        }
  
        .elements {
          color: var(--jump-pagination-table-label);
          display: flex;
          align-items: center;
          gap: 5px;
        }
      }
  
    }
}